module.exports = __webpack_public_path__ + "img/pastille-1sur2.b3fe20f.jpg";